"use strict";

exports.__esModule = true;
exports.hexToRGB = exports.hexToHSL = void 0;
var hexToRGB = exports.hexToRGB = function hexToRGB(hex) {
  var match = hex.match(/#[a-f0-9]{6}$|#[a-f0-9]{3}$/i);
  if (!match) {
    return [0, 0, 0];
  }
  var colorString = match[0].substring(1);
  if (match[0].length === 4) {
    colorString = colorString.split("").map(function (_char) {
      return _char + _char;
    }).join("");
  }
  var integer = parseInt(colorString, 16);
  var r = integer >> 16 & 0xff;
  var g = integer >> 8 & 0xff;
  var b = integer & 0xff;
  return [r, g, b];
};
var hexToHSL = exports.hexToHSL = function hexToHSL(H) {
  var _hexToRGB = hexToRGB(H),
    r = _hexToRGB[0],
    g = _hexToRGB[1],
    b = _hexToRGB[2];
  r /= 255;
  g /= 255;
  b /= 255;
  var cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;
  if (delta == 0) h = 0;else if (cmax == r) h = (g - b) / delta % 6;else if (cmax == g) h = (b - r) / delta + 2;else h = (r - g) / delta + 4;
  h = Math.round(h * 60);
  if (h < 0) h += 360;
  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);
  return [h, s, l];
};